module.exports = __webpack_public_path__ + "static/media/Sec-4-2677_EN.b72fd2df.png";